import React from 'react';
import noop from 'lodash/noop';
import { DropdownItem, DropdownItemGroup } from '@atlaskit/dropdown-menu';
import { useIntl } from '@atlassian/jira-intl';
import messages from '../messages.tsx';
import type { Props } from './types.tsx';

export function MoveInSidebarMenu({
	positionType = 'standard',
	onMoveToTop = noop,
	onMoveUp = noop,
	onMoveDown = noop,
	onMoveToBottom = noop,
}: Props) {
	const { formatMessage } = useIntl();
	return (
		<DropdownItemGroup>
			<DropdownItem isDisabled={positionType === 'first'} onClick={() => onMoveToTop()}>
				{formatMessage(messages.moveToTop)}
			</DropdownItem>
			<DropdownItem isDisabled={positionType === 'first'} onClick={() => onMoveUp()}>
				{formatMessage(messages.moveUp)}
			</DropdownItem>
			<DropdownItem isDisabled={positionType === 'last'} onClick={() => onMoveDown()}>
				{formatMessage(messages.moveDown)}
			</DropdownItem>
			<DropdownItem isDisabled={positionType === 'last'} onClick={() => onMoveToBottom()}>
				{formatMessage(messages.moveToBottom)}
			</DropdownItem>
		</DropdownItemGroup>
	);
}
